<template>
  <qc-container title="商品管理">
    <page-request ref="table" url="/api/mgr/shop/business/goods/list" :table-header="tableHeader" :expend="expend" :prop="{goodsType:0,state:1}" :op-width="200">
      <t-button v-if="!orgId" @click="doEdit()">添加</t-button>
      <t-button @click="batchUpdateStatus(0)">批量下架</t-button>
      <t-button @click="batchUpdateStatus(1)">批量上架</t-button>
      <t-button @click="batchDel()">批量删除</t-button>
      <template #op="scope">
        <b-button @click="doEdit(scope.row)">编辑</b-button>
        <b-button v-show="scope.row.enables===0" @click="updateStatus([scope.row.id],1)">上架</b-button>
        <b-button v-show="scope.row.enables===1" @click="updateStatus([scope.row.id],0)">下架</b-button>
        <!--        <b-button @click="doEdit(scope.row)">库存</b-button>
                <b-button @click="doEdit(scope.row)">规格</b-button>-->
<!--        <b-button v-show="scope.row.isTop===0" @click="updateIsTop(scope.row.id,1)">推荐</b-button>
        <b-button v-show="scope.row.isTop===1" @click="updateIsTop(scope.row.id,0)">取消推荐</b-button>-->
        <b-button @click="doDel([scope.row.id])">删除</b-button>
      </template>
    </page-request>
  </qc-container>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";

export default {
  name: "org-goods-list",
  components: {PageRequest, TButton, BButton, QcContainer},
  data() {
    return {
      tableHeader: [
        {type: "selection", label: ""},
        {type: "goods", label: "商品",minWidth:300},
        {label: "价格",renderDraw:row=>{
            let content = "";
            if(row.storeGoodsType===1 ){
              content = "租赁价格:￥"+row.marketPrice+"元";
            }else if(row.storeGoodsType===2){
              content = "出售价格:￥"+row.salesPrice+"元<br/>"+"租赁价格:￥"+row.marketPrice+"元"
            }else{
              content = "出售价格:￥"+row.salesPrice+"元";
            }
            return content + (row.isAttribute?"起":"");
          },width:220},
        {prop: "inventory", label: "库存",width:100,renderDraw:row=>{
            return row.inventory + (row.marketInventory||0);
          }},
        {label: "状态",renderDraw:row=>{return row.enables?"在售":"下架";},width: 100},
        {prop: "updateTime", label: "更新时间",width:160},
        {prop: "createTime", label: "创建时间",width:160},
      ],
      expend: [
        {label: "商品名称", prop: "name"},
        {label: "商品ID", prop: "codes"},
        {label: "更新时间", start: "updateTimeStart", end: "updateTimeEnd", type: "daterange"},
        {label: "创建时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"}
      ],
    }
  },
  watch:{
    $route(val){
      if(val.path === '/index/lease/goods' || val.path === '/index/org/goods/list'){
        this.pageReloadData();
      }
    }
  },
  mixins: [tableBase],
  methods: {
    doEdit(row) {
      this.toRouter("/index/org/goods/edit",row?{id:row.id,type:this.type}:{})
    },
    doDel(ids) {
      this.msgConfirm("/api/mgr/shop/business/goods/delete", {ids: ids}, () => {
        this.pageReloadData();
      });
    },
    batchUpdateStatus(status) {
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.updateStatus(ids,status);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    updateStatus(ids,enables){
      this.msgConfirm("/api/mgr/shop/business/goods/undercarriage",{ids:ids.join(","),enables:enables},()=>{
        this.pageReloadData();
      },`您是否要${enables?'上架':'下架'}所选商品?`)
    },
    updateIsTop(id,isTop){
      this.msgConfirm("/api/mgr/shop/business/goods/updateIsTop",{id:id,isTop:isTop},()=>{
        this.pageReloadData();
      },`您是否要${isTop?'推荐':'取消推荐'}所选商品?`)
    },
    batchDel(){
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.doDel(ids);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
